module.exports = __webpack_public_path__ + "img/2f_r_sobaichi.20ae6fed.png";